"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemUnitPrice = void 0;
var _mui = require("@ori-ui/mui");
var _context = require("../../context");
var _hooks = require("../../hooks");
var _style = require("./style");
var _jsxRuntime = require("react/jsx-runtime");
const NumberInnerUnit = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  overflow: 'hidden',
  flexFlow: 'row wrap',
  gap: theme.spacing(1),
  width: '100%'
}));
const ItemUnitPrice = () => {
  const {
    isSmall,
    itemTestId,
    quantity,
    unitPrice
  } = (0, _context.useItemContext)();
  const {
    translations
  } = (0, _hooks.useTranslations)();
  const theme = (0, _mui.useTheme)();
  const matches = (0, _mui.useMediaQuery)(theme.breakpoints.up('sm'));
  if (unitPrice && quantity > 1 && !isSmall && matches) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(NumberInnerUnit, {
      "data-testid": `${itemTestId}-unitPrice`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.NumberInnerValue, {
        variant: "caption",
        color: theme.palette.text.secondary,
        children: [translations.unitPrice, ":"]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.NumberInnerValue, {
        variant: "caption",
        color: theme.palette.text.secondary,
        children: unitPrice
      })]
    });
  }
  return null;
};
exports.ItemUnitPrice = ItemUnitPrice;
